import React from 'react';
import Button from '../components/UI/Button';
import { getProductById } from '../data/products';
import './WoprPage.css';
import './ProductHero.css';

const WoprPage = () => {
  const product = getProductById('wopr');

  if (!product) {
    return <div>Product not found</div>;
  }

  return (
    <div className="wopr-page">
      <section className="product-hero product-hero-wopr">
        <div className="product-hero-content">
          <h1 className="product-hero-title">WOPR</h1>
          <p className="product-hero-tagline">{product.tagline}</p>
        </div>
      </section>

      <section className="product-overview-section">
        <div className="container">
          <div className="product-overview">
            <div className="product-overview-image">
              <img src={product.image} alt={product.name} />
            </div>
            <div className="product-overview-content">
              <h2 className="section-title">About {product.name}</h2>
              <p className="product-overview-desc">{product.description}</p>
              <p className="product-overview-desc">
                Access powerful AI capabilities directly from your menu bar. No need to switch
                between applications or open browser tabs. WOPR is always just a click away.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="features-section bg-light">
        <div className="container">
          <h2 className="section-title text-center">Features</h2>
          <p className="section-subtitle text-center" style={{ margin: '0 auto 3rem' }}>
            Everything you need for AI-powered productivity.
          </p>
          <div className="features-grid">
            {product.features.map((feature, index) => (
              <div key={index} className="feature-item">
                <span className="feature-check">✓</span>
                <span className="feature-text">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="get-started-section">
        <div className="container">
          <div className="get-started-grid">
            <div className="get-started-download">
              <h2 className="section-title">Download {product.name}</h2>
              <p className="get-started-subtitle">Free for macOS and Windows</p>
              <div className="download-buttons">
                <Button href={product.downloads.mac.url} variant="primary" size="large">
                  Download for Mac
                </Button>
                <Button href={product.downloads.windows.url} variant="outline-dark" size="large">
                  Download for Windows
                </Button>
              </div>
              <div className="requirements-inline">
                <span className="requirements-label">Requirements:</span>
                {product.requirements.map((req, index) => (
                  <span key={index} className="requirement-tag">{req}</span>
                ))}
              </div>
            </div>
            <div className="get-started-support">
              <h2 className="section-title">Need Help?</h2>
              <p className="get-started-subtitle">
                If you have questions or need support, we're here to help.
              </p>
              <Button to="/contact" variant="outline-dark">
                Contact Support
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WoprPage;
